import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import css from './index.module.scss';
import BsFillTriangleFill from '@/components/UI/svg/Icons/BsFillTriangleFill';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoModal from '@/components/UI/EFVideoModal';

gsap.registerPlugin(ScrollTrigger);

export default function Section2() {
    const { useState, useEffect, useLang, useRouter, gtm } = useGlobal();
    const { t } = useLang('delta_pro_new');
    const { locale } = useRouter();
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    useEffect(() => {
        const TL = gsap.timeline({
            scrollTrigger: {
                trigger: '.section2',
                scrub: true,
                start: 'top bottom-=100',
                end: 'center center',
            },
        });
        const textEle = document.querySelector('.section2 .line2');
        const maxPositionY = 29;
        const maxSize = 37;
        TL.to('.section2', {
            duration: 1,
            immediateRender: true,
            onUpdate() {
                if (!textEle) return;
                const progress = this.progress();
                const currentPositionY = Math.floor(maxPositionY * progress);
                const currentSize = Math.floor(maxSize * progress);
                textEle.setAttribute(
                    'style',
                    `background-image: radial-gradient(circle at 53% ${currentPositionY}%, rgba(248, 251, 255, 0.89), #63686e ${currentSize}%);`,
                );
            },
        });
        return () => {
            TL.kill();
        };
    }, []);

    const videoSourceMap: any = {
        us: 'https://www.youtube.com/embed/ozVzv0jo_BM',
        cn: {
            SD: 'https://videos.ecoflow.com/b496757dbe684c2292ad06a2069744e3/90da871a433f4f6d92112b761edc0320-6a9f4ffe2304e35bdffa8bb730756a0f-fd.mp4',
            HD: 'https://videos.ecoflow.com/b496757dbe684c2292ad06a2069744e3/90da871a433f4f6d92112b761edc0320-f9f11f7878eb13eb490a81b52ec658c9-sd.mp4',
            '2K': 'https://videos.ecoflow.com/original/workflow/41625e27-182edc0094a-0004-9c91-e6d-40030.mp4',
        },
        cis: 'https://www.youtube.com/embed/CbWu9D8uivE',
    };

    return (
        <>
            <div className={`${css.section02} GtmModuleData-section`} data-section-id={'section2'} data-section-title={t('banner_desc')}>
                <div className="line1 font-family-semibolder">{t('ecoflow_delta_pro')}</div>
                <div className="line2 font-family-extrabold">{t('banner_desc')}</div>
                <button
                    onClick={() => {
                        setShowEFVideoModal(true);
                        gtm?.push({
                            event: 'uaEvent',
                            event_name: 'video',
                            title_name: 'EcoFlow DELTA Pro',
                            position: 'Product Detail_1',
                        });
                    }}
                    className="watch-video font-family-medium"
                >
                    {t('watch_video')}
                    <BsFillTriangleFill className="arrow-triangle-right" />
                </button>
            </div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={videoSourceMap[locale] || videoSourceMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </>
    );
}
